/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react';

interface IMakeContextModuleOptions<T> {
  contextName: string;
  defaultValue?: T;
}

export function makeContextModule<T>(options: IMakeContextModuleOptions<T>) {
  const { defaultValue = null, contextName } = options;

  const Context = React.createContext<T>(defaultValue as any);
  Context.displayName = contextName;

  return {
    Context,
  };
}
